import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router";
// import Login from "../Components/Pages/Login/Login";
import LoginRedux from "../Containers/Login/Login-redux";
import Header from "../Components/Header/Header";
// import Home from "../Components/Pages/Home";
import HomeRedux from "../Containers/Home/Home-redux";
import Footer from "../Components/Footer/Footer";
import SellerHome from "../Components/Seller/SellerHome";
import SellerLogin from "../Components/Seller/Login/SellerLogin";
import Cart from "../Components/Pages/Cart";
import SellerHeader from "../Components/Seller/Header/Header";
// import Product from "../Components/Seller/Product";
import StockManagement from "../Components/Seller/StockManagement";
import ShipmentTracking from "../Components/Seller/ShipmentTracking";
import ForbiddenSellerMaster from "../Components/Seller/ForbiddenSellerMaster";
// import Category from "../Components/Seller/Category";
// import Analytics from "../Components/Seller/Analytics";
import Viewcards from "../Components/Pages/Viewcards";
import CategoryProducts from "../Components/Pages/CategoryProducts";
import Brands from "../Components/Pages/Brands";
import ProductDetail from "../Components/Pages/ProductDetail";
import Offers from "../Components/Pages/Offers";
import SearchResults from "../Components/Pages/SearchResults";
// import Dashboard from "../Components/Seller/Dashboard";
import DashboardRedux from "../Containers/Dashboard/Dashboard-redux";
import AnalyticsRedux from "../Containers/Analytics/Analytics-redux";
import OrderRedux from "../Containers/Order/Order-redux";
import AccountRedux from "../Containers/Accounts/Account-redux";
import { Toaster } from "react-hot-toast";
import Story from "../Components/Pages/Aboutus/Story";
import Contactus from "../Components/Pages/Aboutus/Contact";
import Blogs from "../Components/Pages/Aboutus/Blogs";
import BlogDetail from "../Components/Pages/Aboutus/BlogDetail";
import FAQ from "../Components/Pages/FAQs/FAQ";
import SellerSetting from "../Components/Seller/SellerSetting";
import SellerNotifications from "../Components/Seller/Notifications";
import Checkout from "../Components/Pages/Checkout";
import Brandsproduct from "../Components/Pages/Brandsproduct";
import UserOrder from "../Components/Pages/Userorder";
import PaymentSuccess from "../Components/Pages/PaymentSuccess";
import PaymentCancel from "../Components/Pages/PaymentCancel";
import Signup from "../Components/Pages/Register/Register";
import VerifyOtp from "../Components/Pages/VerifyOTP/Verify";
import FloatingContactButtons from "../Common/FloatingContactButtons";
import LoginPopup from "../Components/Pages/Login/Loginpopup";
import { AUTH_MODAL_EVENT } from "../utils/authModal";
import ScrollToTop from "./ScrollToTop";
import { useSellerAuth } from "../Common/SellerAuthContext";
import SellerProtectedRoute from "./SellerProtectedRoute";
import SellerPublicRoute from "./SellerPublicRoute";
import { isSellerProtectedPath } from "../utils/sellerRoutes";
import "../Styles/MobileStorefront.css";
import ClinicalPlannersConsultants from "../Components/Pages/ClinicalPlannersConsultants";
import { CLINICAL_PLANNERS_PATH } from "../utils/clinicalPlanners";

function Navigation() {
  const location = useLocation();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const { isSellerAuthenticated } = useSellerAuth();
  const normalizedPath = String(location.pathname || "").toLowerCase();
  const hideHeaderPaths = ["/seller", "/sellerhome", "/sellerlogin","/signup","/verifyotp", CLINICAL_PLANNERS_PATH];
  const hidefooterpaths = ["/sellerlogin","/signup","/verifyotp", CLINICAL_PLANNERS_PATH];
  const sellerProtectedPage = isSellerProtectedPath(location.pathname);
  const shouldHideHeader =
    hideHeaderPaths.includes(normalizedPath) || sellerProtectedPage;
  const shouldHidefooter =
    hidefooterpaths.includes(normalizedPath) || sellerProtectedPage;

  useEffect(() => {
    const handleAuthModalToggle = (event) => {
      setIsAuthModalOpen(Boolean(event?.detail?.open));
    };

    window.addEventListener(AUTH_MODAL_EVENT, handleAuthModalToggle);

    return () => {
      window.removeEventListener(AUTH_MODAL_EVENT, handleAuthModalToggle);
    };
  }, []);

  // console.log('hello---->',location.pathname)

  return (
    <>
      <ScrollToTop />
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName="toast-container"
        containerStyle={{
          zIndex: 999999,
        }}
        toastOptions={{
          className: "",
          duration: 4000,
          style: {
            background: "#363636",
            color: "#fff",
            zIndex: 999999,
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
            style: {
              background: "#10b981",
              color: "white",
              fontWeight: "500",
              fontSize: "14px",
              borderRadius: "8px",
              padding: "12px 16px",
              zIndex: 999999,
              boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
            },
            iconTheme: {
              primary: "white",
              secondary: "#10b981",
            },
          },
          error: {
            duration: 4000,
            style: {
              background: "#ef4444",
              color: "white",
              fontWeight: "500",
              fontSize: "14px",
              borderRadius: "8px",
              padding: "12px 16px",
              zIndex: 999999,
              boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)",
            },
            iconTheme: {
              primary: "white",
              secondary: "#ef4444",
            },
          },
          loading: {
            duration: Infinity,
            style: {
              background: "#3b82f6",
              color: "white",
              fontWeight: "500",
              fontSize: "14px",
              borderRadius: "8px",
              padding: "12px 16px",
              zIndex: 999999,
            },
          },
        }}
      />
      {/* <Header /> */}
      {!shouldHideHeader && <Header />}
      {sellerProtectedPage && isSellerAuthenticated && <SellerHeader />}
      <Routes>
        <Route path="/login" element={<LoginRedux />} />
        <Route path="/" element={<HomeRedux />} />
        <Route path={CLINICAL_PLANNERS_PATH} element={<ClinicalPlannersConsultants />} />
        <Route path="/seller" element={<SellerHome />} />
        <Route path="/sellerhome" element={<SellerHome />} />
        <Route
          path="/sellerlogin"
          element={
            <SellerPublicRoute>
              <SellerLogin />
            </SellerPublicRoute>
          }
        />
        <Route
          path="/sellerLogin"
          element={<Navigate replace to="/sellerlogin" />}
        />
        <Route path="/account" element={<AccountRedux />} />
        <Route path="/cart" element={<Cart />} />
        {/* <Route path="/dashboard" element={<SellerDashboard />} /> */}
        <Route
          path="/seller/product"
          element={
            <SellerProtectedRoute>
              <StockManagement />
            </SellerProtectedRoute>
          }
        />
        <Route
          path="/seller/products"
          element={
            <SellerProtectedRoute>
              <StockManagement />
            </SellerProtectedRoute>
          }
        />
        <Route
          path="/seller/order"
          element={
            <SellerProtectedRoute>
              <OrderRedux />
            </SellerProtectedRoute>
          }
        />
        <Route
          path="/seller/orders"
          element={
            <SellerProtectedRoute>
              <OrderRedux />
            </SellerProtectedRoute>
          }
        />
        <Route
          path="/seller/notifications"
          element={
            <SellerProtectedRoute>
              <SellerNotifications />
            </SellerProtectedRoute>
          }
        />
        <Route
          path="/seller/category"
          element={
            <SellerProtectedRoute>
              <ForbiddenSellerMaster />
            </SellerProtectedRoute>
          }
        />
        <Route
          path="/seller/tracking"
          element={
            <SellerProtectedRoute>
              <ShipmentTracking />
            </SellerProtectedRoute>
          }
        />
        <Route
          path="/seller/analytics"
          element={
            <SellerProtectedRoute>
              <AnalyticsRedux />
            </SellerProtectedRoute>
          }
        />
        <Route path="/viewall/:id" element={<Viewcards />} />
        <Route path="/categoryproducts" element={<CategoryProducts />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/search" element={<SearchResults />} />
        <Route
          path="/dashboard"
          element={
            <SellerProtectedRoute>
              <DashboardRedux />
            </SellerProtectedRoute>
          }
        />
        <Route
          path="/seller/dashboard"
          element={
            <SellerProtectedRoute>
              <DashboardRedux />
            </SellerProtectedRoute>
          }
        />
        <Route path="/story" element={<Story />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/faq/:slug" element={<FAQ />} />
        <Route
          path="/sellersetting"
          element={
            <SellerProtectedRoute>
              <SellerSetting />
            </SellerProtectedRoute>
          }
        />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/brandsproduct/:id" element={<Brandsproduct />} />
        <Route path="/userorder" element={<UserOrder />} />
        <Route path="/userorder/:orderId" element={<UserOrder />} />
        <Route path="/account/orders/:orderId" element={<UserOrder />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/auth/google/callback" element={<HomeRedux />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verifyotp" element={<VerifyOtp />} />

        {/* <Route path="/sellerdashboard" element={<SellerDashboard /> } />   */}
      </Routes>
      {!shouldHidefooter && <Footer />}
      {!shouldHidefooter && <FloatingContactButtons />}
      {normalizedPath !== CLINICAL_PLANNERS_PATH && <LoginPopup
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />}
    </>
  );
}

export default Navigation;
